const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getOrgs() {
  const response = await fetch(`${API_BASE}/orgs`, {
    credentials: 'include'
  });
  
  if (!response.ok) {
    if (response.status === 401) {
      return [];
    }
    throw new Error('Failed to fetch organizations');
  }
  
  const data = await response.json();
  return data.orgs;
}

export async function getOrgContext(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/context`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch organization context');
  }
  
  return response.json();
}
